import Vue from 'vue'
import qs from 'qs';
import { get, reduce, cloneDeep, noop } from 'lodash';
import plans from "@/plans";
import {
  ACCOUNT_SALE_CHANNEL,
  AUDIO_SUB_TYPES,
  AccountType,
  BILLING_CYCLE,
  MRS_STATUS_TYPE_MAP,
  planTypes,
  twinPlancodesMap,
} from '@/common/constants';
import { getBasePlanInfo, groupByPlanTypeGetter, getMeetingPlans, getPlansMap } from '@/common/product';
import pageFlow from '@/flows';
import { getCartInfo } from "@/common/service/default-mapper";
import { COUPON_ACTION_TYPES } from '@/store/modules/coupon';
import _ from 'lodash';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { boughtPlanFilter } from '@/common/service/bought-plans-filter';
import { checkMRSChange, planCodeMapSubscriptionDisabled } from '@/utils/validator';
import { PAYMENT_ACTION_TYPES } from '@/store/modules/payment';
import { ADDRESS_ACTION_TYPES } from '@/store/modules/address';
import { sortSelectedPlansMethod } from '@/plans';
import {
  cancellationCouponSource,
  couponFetchStatus,
  couponSourceTypeMap,
} from '@/views/config/coupon/helper/constant';
import { plansof } from '@/utils/chain';
import log from '@/common/log';
import { unlimitedAudioLicenseGetter } from '@/common/service/audio-us-ca';
import { plansofBizBundle } from '@/plans/ZOOM_ONE_BUNDLE/utils';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';
import { isOnlineNotSupportPlan } from '@/common/service/non-standard-billing-cycle-utils';
import { MIGRATE_FLOW_TYPES } from '@/plans/ZOOM_MEETING/dialog/migration-plan';
import { $context, $query } from '@/global-install';
import { getCountryCodeByBusinessCountry } from '@/plans/ZOOM_MEETING/config/healthcare/helpers'
import { isFromCampaignLink } from '@/views/config/coupon/helper/utils';
import { ZoomRoomCategories } from '@/plans/ZOOM_ROOMS/pre';
import { getFreeTrialPlansByCampaignName } from '@/apis';
import { isSelectedPlanMixedFreeTrial } from '@/common/service/free-trial';
import { isFromShoppingCart } from '@/views/config/shopping-cart/persist/plan-remove';
import { getInrDiscountAmount } from '@/views/config/shopping-cart/inr-discount/inr-discount';

const SELECTED_PLANS_MAP_0_KEY = window.location.search;

const getDefaultCouponPayload = () => {
  return {
    cancelCampaign: false,
    fromCampaignLink: false,
    supportCoupon: false,
    code: undefined,
  }
};

function getDeterminePlanBeenEditedData(plan) {
  // diff plan codes but the same thing
  const plan_code = twinPlancodesMap[plan.plan_code] || plan.plan_code;
  const quantity = plan.cartInfo.selected_number;
  let special = '';
  // tollFree cares whether tollFreeProfileData changes
  if (plan.type === planTypes.TOLLFREE && plan.category === AUDIO_SUB_TYPES.TOLL_FREE) {
    special = `tollFreeProfileData=${JSON.stringify(plan.cartInfo.tollFreeProfileData || {})}`;
  }
  return `${plan_code}*${quantity}${special}\n`;
}

export function getMultipleRatePlanSumPrice(boughtPlan, selectedNumber) {
  const boughtNum = _.sum(boughtPlan.ratePlans.map((ratePlan) => ratePlan.quantity));
  const addNum = selectedNumber - boughtNum;
  const addSumPrice = boughtPlan.ratePlans.find(r => r.useForUpsell)?.price * addNum;
  return _.sum(boughtPlan.ratePlans.map((ratePlan) => ratePlan.quantity * ratePlan.price)) + addSumPrice;
}

const state = {
  refreshCount: 0,
  planMapFlat: [],
  planMapFlatRaw: [], // untouched full plans list, planMapFlat is changed through multiple loaders
  boughtPlans: [],
  freeTrialPlans: [],
  subscriptions: [],
  preloadCartInfo: {},
  persist: {}, // TODO persist data should be dependent on flow type: destroy persist of different flow
  selectedPlansMap0: {},
  allPlanMap: {},
  cartIsReady: false,
  flowInitIsReady: false,
  assignInfo: {}, // key is planCode, value is object
  cmrUsedValue: {},
  persistState: {
    downgradeState: {
      //status: 0, //-1:down 0:unChange 1:up
    },
    migratePlanState: {
      planList: [],
      flow: '',
      hotCache: {},
      migrateType: ''
    },
    confirmationDetails: {},
    accountBizInfo:{
      businessPersonalAccount:		'',
      businessSize: '',
      businessRegion: '',
    }
  }, // business persist state
  currentEditPlan :{},
  sourcePlan: null, // for upgrade
  // PRO INCREASE - store the old price when user not save address and try to go back
  proIncreaseMapMonthly: {
    address: undefined,
    oldPlanCode: undefined,
    oldPlanAmount: undefined,
    newPlanCode: undefined,
    newPlanAmount: undefined
  },
  proIncreaseMapYearly: {
    address: undefined,
    oldPlanCode: undefined,
    oldPlanAmount: undefined,
    newPlanCode: undefined,
    newPlanAmount: undefined
  },
  _healthcareInfo: {
    agreementAccepted: false,
    businessCountry: '',
  },
  draftPlanFilterKeys: [],
  trialInfoMap: {}
};

const getters = {
  cartIsReady: (state) => state.cartIsReady,
  flowInitIsReady: (state) => state.flowInitIsReady,
  boughtPlans: (state) => state.boughtPlans,
  freeTrialPlans: (state) => state.freeTrialPlans,
  planMapFlat: (state) => state.planMapFlat,
  planMapFlatRaw: (state) => state.planMapFlatRaw,
  draftPlanFilterKeys: (state) => state.draftPlanFilterKeys,
  groupByPlanCodePlanMap: (state) => getPlansMap(state.planMapFlat),
  getTypeGroupSelectedPlans: (state, { getSelectedPlans }) => groupByPlanTypeGetter(getSelectedPlans),
  // shopping cart plans.
  getSelectedPlans: ({ planMapFlat }) => {
    return planMapFlat.filter(v => v.cartInfo?.selected_number > 0).sort(sortSelectedPlansMethod);
  },
  getSelectedPlansCartInfo: ({ planMapFlat }) => {
    return planMapFlat.filter(v => v.cartInfo?.selected_number > 0).sort(sortSelectedPlansMethod).map(item => {
      return {
        ...item,
        selected_number: item.cartInfo.selected_number,
      }
    });
  },
  editablePlansInBought(state, getters){
    const { boughtPlans } = getters;
    const selectedPlansMap0 = state.selectedPlansMap0[SELECTED_PLANS_MAP_0_KEY]??{};
    return boughtPlans.filter(x => selectedPlansMap0[x.plan_code]); // [init0 plans] ∩ [bought plans] => original target edit plans
  },
  isSelectedSameAsEditablePlansInBought: (state, getters) => {
    // shopping cart plans === ([init0 plans] ∩ [bought plans])   (excluding modified plans from coupon, etc.)
    if(window.newBillingConfig?.forcePlaceorderActive || window.forcePlaceorderActive) return false;
    if(getters.couponState?.couponCode) return false; // same plancode & quantity but with discount from campaign link coupon
    const { getSelectedPlans, editablePlansInBought } = getters;
    if (!editablePlansInBought.length) return false;
    // FREE TRIAL - the user could just bought a free trial plan with 0 price but same plan code with paid plan
    if(editablePlansInBought.some(plan => !!plan.freeTrialPlanInfo && plan.freeTrialPlanInfo.price === 0)) {
      return false;
    }
    const arr = [editablePlansInBought, getSelectedPlans].map(plan => {
      return _.sortBy(plan, 'plan_code').reduce((acc, x) => acc + getDeterminePlanBeenEditedData(x), '');
    });
    return arr[0] === arr[1];
  },
  isSelectedCycleSameAsEditablePlansInBought: (state, getters) => {
    const { isSelectedSameAsEditablePlansInBought, getSelectedPlans, editablePlansInBought } = getters;
    if (isSelectedSameAsEditablePlansInBought) {
      return true;
    }
    let sameCycle = true;
    _.each(editablePlansInBought, function(plan) {
      const matchingItem = _.find(getSelectedPlans, tmp => tmp.type === plan.type);
      if (!matchingItem || matchingItem.billing_cycle !== plan.billing_cycle) {
        sameCycle = false;
      }
    });
    return sameCycle;
  },
  cartFingerPrint: (state, getters) => {
    // mainly to indicate that cart has changed
    // TODO not for plans like Zoom Phone
    const { getSelectedPlans } = getters;
    return getSelectedPlans.map(plan => getDeterminePlanBeenEditedData(plan)).join('\n');
  },
  // key is planCode, value is quantity
  getSelectedPlansWithQuantityMap: (_, getters) => {
    return reduce(getters.getSelectedPlans, (res, item) => {
      if (item.plan_code) {
        res[item.plan_code] = get(item, 'cartInfo.selected_number');
      }

      return res;
    }, {});
  },
  // key is planCode, value is quantity
  getSelectedFreeTrialPlansWithQuantityMap: (_, getters) => {
    return reduce(getters.getSelectedPlans, (res, item) => {
      if (item.plan_code && item.isOnlineFreeTrial) {
        res[item.plan_code] = get(item, 'cartInfo.selected_number');
      }
      return res;
    }, {});
  },
  // just generate order data with api payload params
  selectedPlanListPayLoad: (_, { getSelectedPlans }) => {
    let list = cloneDeep(getSelectedPlans);

    list = list.filter(p => {
      // remove pro single use plan
      if (p.type === planTypes.ZOOM_MEETING && p.billing_cycle === BILLING_CYCLE.ONE_TIME) return false;
      return true;
    });

    // post process before data is sent
    plans.forEach(PLAN => {
      const planType = planTypes[PLAN.key];
      const post = PLAN.post || noop;
      post(plansof(list).type(planType).get());
    });

    return list?.map((plan) => {
      const res = {
        quantity: plan.cartInfo.selected_number,
        planCode: plan.plan_code
      };
      // FREE TRIAL - free trial data need more info like trialDays
      if (plan.isOnlineFreeTrial && plan.trialDays) {
        res.trialCode = plan.trialCode || '';
        // Only if buy normal plan and free trial plan together, we should add planExtension field here.
        // Otherwise submit api will return error
        if (isSelectedPlanMixedFreeTrial()) {
          res.planExtension = {
            campaignCode: plan.campaignCode,
            trialCode: plan.trialCode,
            freeTrialSource: qs.parse(location.search.slice(1))['itm_source'] || 'Direct Link'
          }
        }
      }
      //special billing cycle plan should distinguish by plan_type
      if (isOnlineNotSupportPlan({
        planType: plan.type,
        billingCycle: plan.billing_cycle,
        category: plan.category
      })) {
        res.planType = plan.plan_type;
      }
      return res;
    })
  },
  couponPayload: (state, getters) => {
    const couponState = getters.couponState;

    const defaultCouponPayload = {
      ...getDefaultCouponPayload(),
      code: couponState?.couponCode,
    };

    // for supported coupon case
    if (couponState.couponSourceType === couponSourceTypeMap.supportCoupon) {
      return {
        ...defaultCouponPayload,
        supportCoupon: true,
      };
    }

    // NN/FREE or not from campaign link
    if (window.$context.is.basic2pro || window.$context.is.buyNow || !couponState?.fromPreloadLink) {
      return defaultCouponPayload;
    }

    if (window.$config('cp_source') === cancellationCouponSource) {
      return {
        ...defaultCouponPayload,
        cancelCampaign: true,
      };
    }

    return {
      ...defaultCouponPayload,
      fromCampaignLink: true,
    };
  },
  orderDataPayload: (_, getters) => {
    const couponVerifyStatus = getters.verifyCouponStatus;

    return {
      planList: getters.selectedPlanListPayLoad,
      coupon: couponVerifyStatus !== couponFetchStatus.failure ?
        getters.couponPayload : getDefaultCouponPayload(),
    }
  },
  // Merge bought plans and selected plans.
  getUserCurrentSubscriptions: (state, getters) => {
    const boughtPlans = boughtPlanFilter(getters);

    const allPlans = [
      ...boughtPlans,
      ...getters.getSelectedPlans,
    ];
    let cacheKey = {};
    const mergedPlans = [];
    allPlans.forEach(item => {
      if (cacheKey[item.category]) {
        return;
      }
      const { category } = item;
      const selectedPlan = getters.getSelectedPlans.find(_item => _item.category === item.category);
      if (selectedPlan) {
        mergedPlans.push(selectedPlan);
      } else {
        mergedPlans.push(item);
      }
      cacheKey[category] = true;
    });
    cacheKey = null;
    return mergedPlans;
  },
  getSelectedPlansMap: (state, { getSelectedPlans }) => {
    return reduce(getSelectedPlans, (res, item) => {
      if (item.plan_code) {
        res[item.plan_code] = item;
      }
      return res;
    }, {});
  },
  getSelectedPlansAmount: (state, getters) => {
    const { getSelectedPlans, getUsCaBasePlansNumber, boughtPlans } = getters;

    const inrDiscountAmount = getInrDiscountAmount();
    let monthlyAmount = 0;
    let annualAmount = inrDiscountAmount;
    let quarterlyAmount = 0;
    let twoYearsAmount = 0;
    let threeYearsAmount = 0;
    let totalAmount = inrDiscountAmount;
    let plans = {};

    for (let i = 0; i < getSelectedPlans.length; i++) {
      const plan = getSelectedPlans[i];
      const { billing_cycle } = plan;
      let amount = 0;
      const boughtPlan = boughtPlans.find((bp) => bp.billing_cycle === plan.billing_cycle && bp.plan_code === plan.plan_code);
      if (plan.category === AUDIO_SUB_TYPES.UNLIMITED) {
        if (boughtPlan?.ratePlans?.length > 1) {
          amount += getMultipleRatePlanSumPrice(boughtPlan, getUsCaBasePlansNumber);
        } else {
          amount += plan.amount * getUsCaBasePlansNumber;
        }
      } else {
        if (boughtPlan?.ratePlans?.length > 1) {
          amount += getMultipleRatePlanSumPrice(boughtPlan, plan.cartInfo.selected_number);
        } else {
          amount += plan.amount * plan.cartInfo.selected_number;
        }
      }

      if (billing_cycle === BILLING_CYCLE.ANNUAL) {
        annualAmount += amount;
      } else if (billing_cycle === BILLING_CYCLE.MONTHLY) {
        monthlyAmount += amount;
      } else if (billing_cycle === BILLING_CYCLE.QUARTERLY) {
        quarterlyAmount += amount;
      } else if (billing_cycle === BILLING_CYCLE.TWO_YEARS) {
        twoYearsAmount += amount;
      } else if (billing_cycle === BILLING_CYCLE.THREE_YEARS) {
        threeYearsAmount += amount;
      }
      if (!plan.isOnlineFreeTrial) {
        totalAmount += amount;
      }
      plans[plan.plan_code] = amount;
    }

    return {
      monthlyAmount,
      annualAmount,
      quarterlyAmount,
      twoYearsAmount,
      threeYearsAmount,
      totalAmount,
      plans,
    };
  },
  getTotalCharge: (state, getters) => {
    const { getSelectedPlansAmount, discountWithAmountMap, getSelectedPlans } = getters;

    // if the customer's shopping cart don't have any plans, should set default amount with zero
    if (discountWithAmountMap.totalDiscount > 0 && !getSelectedPlans.length) return 0;

    return (getSelectedPlansAmount.totalAmount - discountWithAmountMap.totalDiscount);
  },
  // for merge bought plans and selected plans
  getCurrentBasePlanInfo: (_, getters) => getBasePlanInfo(getters.getUserCurrentSubscriptions),
  getCurrentMeetingPlans: (_, getters) => getMeetingPlans(getters.getUserCurrentSubscriptions),
  getBoughtBasePlanInfo: (_, getters) => getBasePlanInfo(getters.boughtPlans),
  getSelectedBasePlanInfo: (_, getters) => getBasePlanInfo(getters.getSelectedPlans),
  getBoughtMeetingPlans: (_, getters) => getMeetingPlans(getters.boughtPlans),
  getSubscriptions(state){
    return state.subscriptions;
  },
  subscriptions: (state) => state.subscriptions,
  assignInfo: (state) => state.assignInfo,
  cmrUsedValue: (state) => state.cmrUsedValue,
  plancodeMapSubscriptionDisabled(state, getters){
    // plancode map subscription disabled status
    return planCodeMapSubscriptionDisabled(getters.getSubscriptions);
  },
  boughtPlansGroupByCategoryCode: (_, getters) => {
    return getters.boughtPlans.reduce((pre, item) => {
      pre[item.category] = pre[item.category] || [];
      pre[item.category].push(item);

      return pre;
    }, {});
  },
  currentEditPlan: (state, getters) => {
    return _.find(getters.boughtPlans, (p) => {
      const planCodeList = [p?.plan_code, p?.mapping_plan_code].filter(Boolean);
      return _.includes(planCodeList, pageConfig?.oldPlanCode);
    });
  },
  currentEditPlanMRRStatus(state, getters){
    const {currentEditPlan, getSelectedPlans} = getters;
    // in most cases, a user could edit only one plan
    // but for some, supplementary zoom one plans might be added, if so, MRR is sure to be CHANGE_NOW;
    if(getSelectedPlans.length > 1) return MRS_STATUS_TYPE_MAP.CHANGE_NOW;
    // check plan MRR status
    return checkMRSChange({oldPlan: currentEditPlan, nextPlan: getSelectedPlans[0]});
  },
  isCurrentEditUpSell(state, getters){
    return getters.currentEditPlanMRRStatus === MRS_STATUS_TYPE_MAP.CHANGE_NOW;
  },
  isCurrentEditDownSell(_, getters) {
    return getters.currentEditPlanMRRStatus === MRS_STATUS_TYPE_MAP.CHANGE_FUTURE;
  },
  isCurrentMeetingPlanDowngrade: (_, getters) => {
    const oldCategory = getters.currentEditPlan?.category;
    const newCategory = getters.getCurrentMeetingPlans[0]?.category;
    const orderZoneCategory = [ZOOM_MEETING_SUB_TYPES.PRO, ZOOM_MEETING_SUB_TYPES.PRO_PLUS, ZOOM_MEETING_SUB_TYPES.BIZ, ZOOM_MEETING_SUB_TYPES.BIZ_PLUS];
    return orderZoneCategory.indexOf(oldCategory) > orderZoneCategory.indexOf(newCategory)
  },
  smbShouldFollowTermEndDate: (_, getters) => {
    return getters.basicConfig?.isSMBCustomer
    && getters.basicConfig?.term !== getters.currentEditPlan?.cycleValue
    && (getters.isCurrentEditDownSell || getters.isCurrentMeetingPlanDowngrade);
  },
  shouldUseTermEndDate: (_, getters) => {
    //1.when smb customer product term and contract term are different, downgrade/downsell should be executed based on the contract term
    //2.when customer biz>pro, biz plus>biz, downgrade should be executed based on the contract term
    return getters.smbShouldFollowTermEndDate || getters.isCurrentMeetingPlanDowngrade || $context.is.biz2pro
  },
  isCancelAndReplaceSubscription: (_, getters) => {
    const oldCategory = getters.currentEditPlan?.category;
    const newCategory = getters.getSelectedPlans[0]?.category;
    const meetingScope = [ZOOM_MEETING_SUB_TYPES.EDUCATION, ZOOM_MEETING_SUB_TYPES.PRO, ZOOM_MEETING_SUB_TYPES.PRO_PLUS, ZOOM_MEETING_SUB_TYPES.BIZ, ZOOM_MEETING_SUB_TYPES.BIZ_PLUS];
    const isEditBaseZr = getters.account.accountType === AccountType.ACCOUNT_ZOOM_ROOM && getters.currentEditPlan?.category === ZoomRoomCategories.ZR;
    const isEditMeetingPlan = meetingScope.includes(oldCategory) && meetingScope.includes(newCategory);

    // cancellation campaign/marketing campaign
    const isAddCoupon = isFromCampaignLink() && (getters.verifyCouponStatus === couponFetchStatus.pending || getters.discountWithAmountMap?.totalDiscount > 0);
    if (isAddCoupon) return true;

    if (!isEditBaseZr && !isEditMeetingPlan) {
      return false;
    }

    const oldBillingCycle = getters.currentEditPlan?.billing_cycle;
    const newBillingCycle = getters.getSelectedPlans[0]?.billing_cycle;
    const isM2A = oldBillingCycle === BILLING_CYCLE.MONTHLY && newBillingCycle === BILLING_CYCLE.ANNUAL;


    if (isEditMeetingPlan) {
      //case 1: pro,biz,pro plus,biz plus edit flow m2a or use coupon
      if (oldCategory === newCategory) {
        return isM2A;
      }

      //case 2: upgrade flow m2a
      if (meetingScope.indexOf(oldCategory) <= meetingScope.indexOf(newCategory)) {
        return isM2A;
      }
    } else if (isEditBaseZr) {
      return isM2A;
    }

    return false
  },
  persistState: (state) => state.persistState,
  hasBoughtDependPlan: (state, getters) => {
    const editPlanType = pageConfig?.editConfig?.planType;
    const curSelectedPlan = _.find(getters.getSelectedPlans, (p) => p.type === editPlanType);
    const dependBasePlanTypeList = _.get(curSelectedPlan, ["dependBasePlanTypeList"], []);

    if (!dependBasePlanTypeList?.length) return true;

    return !!_.find(getters.boughtPlans, (p) => _.includes(dependBasePlanTypeList, p.type));
  },
  unlimitedAudioLicense: (_, getters) => unlimitedAudioLicenseGetter(getters.getUserCurrentSubscriptions),
  plansofBizBundle: (_, getters) => plansofBizBundle(getters),
  migratePlanState: (state) => {
    const states = state.persistState.migratePlanState;
    let migrateType = states.migrateType;
    if (window.$context.is.biz2bundle) {
      migrateType = MIGRATE_FLOW_TYPES.biz2bundle;
    } else if (window.$context.is.pro2prop) {
      migrateType = MIGRATE_FLOW_TYPES.pro2prop;
    } else if (window.$context.is.prop2bundle) {
      migrateType = MIGRATE_FLOW_TYPES.prop2bundle;
    } else if (window.$context.is.pro2bundle) {
      migrateType = MIGRATE_FLOW_TYPES.pro2bundle;
    } else if (window.$context.is.esc2escp) {
      migrateType = MIGRATE_FLOW_TYPES.eduschcmp2eduschcmpplus
    }
    return {
      ...states,
      migrateType,
      is: {
        downgrade: states.flow === flowTypes.downgrade || window.$context.is.biz2pro,
        upgrade: states.flow === flowTypes.upgrade || window.$context.is.biz2bundle || window.$context.is.pro2prop || window.$context.is.prop2bundle || window.$context.is.pro2bundle || window.$context.is.pro2biz ||  window.$context.is.esc2escp,
        bundle2biz: states.migrateType === MIGRATE_FLOW_TYPES.bundle2biz,
        escp2esc: states.migrateType === MIGRATE_FLOW_TYPES.eduschcmpplus2eduschcmp,
        esc2escp: states.migrateType === MIGRATE_FLOW_TYPES.eduschcmp2eduschcmpplus,
        pro2bundle: states.migrateType === MIGRATE_FLOW_TYPES.pro2bundle,
        pro2biz: states.migrateType === MIGRATE_FLOW_TYPES.pro2biz || window.$context.is.pro2biz,
        biz2bundle: states.migrateType === MIGRATE_FLOW_TYPES.biz2bundle || window.$context.is.biz2bundle,
        biz2pro: states.migrateType === MIGRATE_FLOW_TYPES.biz2pro || window.$context.is.biz2pro,
        bundle2pro: states.migrateType === MIGRATE_FLOW_TYPES.bundle2pro,
        pro2prop: states.migrateType === MIGRATE_FLOW_TYPES.pro2prop || window.$context.is.pro2prop,
        prop2bundle: states.migrateType === MIGRATE_FLOW_TYPES.prop2bundle || window.$context.is.prop2bundle,
        biz2proplus: states.migrateType === MIGRATE_FLOW_TYPES.biz2proplus,
        bizplus2proplus: states.migrateType === MIGRATE_FLOW_TYPES.bizplus2proplus,
      }
    }
  },
  hasPendingRequest(_, getters) {
    return getters.subscriptions.reduce((prev, cur) => {
      prev[cur.plan_code] = cur.has_downgrade_request || cur.has_decrease_request || cur.has_same_pending_plan;
      return prev;
    }, {});
  },
  hasDowngradeRequest(_, getters) {
    return getters.subscriptions.reduce((prev, cur) => {
      prev[cur.plan_code] = cur.has_downgrade_request;
      return prev;
    }, {});
  },
  preloadCartInfo(state){
    return state.preloadCartInfo;
  },
  isDisableAdd2Cart(_, getters) {
    const hasQuarterlyPlan = getters.boughtPlans.some((p) => BILLING_CYCLE.QUARTERLY === p.billing_cycle);
    const isNotOnlineAccount = getters.basicConfig?.salesChannel && getters.basicConfig?.salesChannel !== ACCOUNT_SALE_CHANNEL.ONLINE;
    const isSMBCustomer = getters.basicConfig?.isSMBCustomer;
    return hasQuarterlyPlan && isNotOnlineAccount && !isSMBCustomer;
  },
  isOnlineFreeTrailAccount(state) {
    return (
      pageConfig.accountType === AccountType.ACCOUNT_ZOOM_BASIC_MEETING &&
      state.subscriptions.length > 0 &&
      state.subscriptions.filter((item) => !(item.isFreeTrial || item.isOnlineFreeTrial)).length === 0
    );
  },
  isPrecise(state, _, rootState) {
    if ($context.is.buyTrial || $context.is.add2trial) return true;
    // (isNetNew || isPreviewable) && api no exception
    if ($context.is.basic2pro || $context.is.buyNow) {
      return rootState.Tax.isTaxEstimatedSuccess;
    }
    return false;
  },
  healthcareAvailable(state, getters) {
    return (
      $query.referrer === 'healthcare' &&
      ($context.is.buyNow || ($context.is.basic2pro && !getters.isOnlineFreeTrailAccount)) &&
      plansof(getters.getSelectedPlans).type(planTypes.ZOOM_MEETING).category(ZOOM_MEETING_SUB_TYPES.PRO).has()
    )
  },
  healthcareInfo(state, getters) {
    const { agreementAccepted = false, businessCountry = '' } = getters.healthcareAvailable ? state._healthcareInfo : {}
    const countryCode = getCountryCodeByBusinessCountry(businessCountry)
    return {
      ...state._healthcareInfo,
      agreementAccepted,
      businessCountry,
      countryCode,
    }
  },
  healthcareEligible(state, getters) {
    const { agreementAccepted, countryCode } = getters.healthcareInfo
    return agreementAccepted && countryCode === getters.addressInfo.country
  },
  selectedSingleUsePro(state, getters) {
    return getters.getSelectedPlans.find(p => p.type === planTypes.ZOOM_MEETING && p.billing_cycle === BILLING_CYCLE.ONE_TIME);
  },
  trialInfoList(state) {
    const result = []
    for (const campaignCode in state.trialInfoMap) {
      state.trialInfoMap[campaignCode].forEach(item => {
        result.push({
          ...item, campaignCode
        })
      })
    }
    return result
  },
  beforeTaxTotalAmount(state, getters) {
    const total = getters.getTotalCharge + getters.openInvoiceTotalAmount;
    return Math.max(total, 0);
  },
  includeTaxTotalAmount(state, getters) {
    const total = getters.getTotalCharge + getters.getTaxTotalAmount + getters.openInvoiceTotalAmount;
    return Math.max(total, 0);
  },
  omniTotalAmount(state, getters){
    if(getters.isProrated){
      return Math.max(0, getters.getTodaysTotal);
    };
    if(getters.getSelectedPlans.every(plan => !!plan.isOnlineFreeTrial)){
      return 0;
    };
    if($context.is.delta || getters.isInrCitEligible && getters.isProratedChargeAmountCalculated){
      return getters.getProratedChargeTotalAmount
    };
    if($context.is.modal){
      return getters.beforeTaxTotalAmount;
    };
    return getters.includeTaxTotalAmount;
  },
  sourcePlan: state => state.sourcePlan,
};

const mutations = {
  destroyPersist(state) {
    state.persist = {};
  },
  savePersist(state) {
    const persist = state.planMapFlat.reduce((acc, x) => {
      if (x.cartInfo?.selected_number > 0) {
        acc[x.plan_code] = x.cartInfo;
        if (x.isOnlineFreeTrial) {
          acc[x.plan_code].trialInfo = {
            trialCode: x.trialCode,
            trialDays: x.trialDays,
            campaignCode: x.campaignCode,
            isOnlineFreeTrial: x.isOnlineFreeTrial,
          };
        }
      }
      return acc;
    }, {});
    persist._ = +new Date();
    state.persist = persist;
  },
  removePersistTrialInfo(state, planCode) {
    for (let i in state.persist) {
      if (i === planCode) {
        delete state.persist[i].trialInfo;
      }
    }
  },
  setSelectedPlansMap0(state, data) {
    if (state.selectedPlansMap0[SELECTED_PLANS_MAP_0_KEY]) return;
    state.selectedPlansMap0[SELECTED_PLANS_MAP_0_KEY] = data;
  },
  setPlanMapFlat(state, data) {
    state.planMapFlat = data;
  },
  setPlanMapFlatRaw(state, data) {
    state.planMapFlatRaw = data;
  },
  setSubscriptions(state, data) {
    state.subscriptions = data;
  },
  setBoughtPlans(state, data) {
    state.boughtPlans = data;
  },
  setFreeTrialPlans(state, data) {
    state.freeTrialPlans = data;
  },
  setPreloadCartInfo(state, data) {
    state.preloadCartInfo = data;
  },
  setDraftPlanFilterKeys(state, data) {
    state.draftPlanFilterKeys = data;
  },
  removeDraftPlanFilterKeysByKey(state, key) {
    const draftPlanFilterKeys = [...state.draftPlanFilterKeys];
    draftPlanFilterKeys.splice(
      state.draftPlanFilterKeys.findIndex((x) => x === key),      // FIXME: potential risk, when index return -1, this may delete the last one
      1,
    );
    this.commit('setDraftPlanFilterKeys', draftPlanFilterKeys);
  },
  setPlanFreeTrial(state, { type, planCode }) {
    let list = state.planMapFlat;
    if (type) {
      list = list.filter((item) => item.type === type);
    }
    if (planCode) {
      list = list.filter((item) => item.plan_code === planCode);
    }
    list.forEach((plan) => {
      const trialInfo = this.getters.trialInfoList.find((info) => info.planCode === plan.plan_code);
      plan.trialCode = trialInfo.trialCode;
      plan.trialDays = trialInfo.trialDays;
      plan.campaignCode = trialInfo.campaignCode;
      plan.isOnlineFreeTrial = true;
    });
    state.planMapFlat = [...state.planMapFlat];
    this.commit('savePersist');
  },
  removePlanFreeTrial(state, { type, planCode }) {
    let list = state.planMapFlat;
    if (type) {
      list = list.filter((item) => item.type === type);
    }
    if (planCode) {
      list = list.filter((item) => item.plan_code === planCode);
    }
    list.forEach((item) => {
      item.trialCode = '';
      item.trialDays = undefined;
      item.isOnlineFreeTrial = false;
      item.campaignCode = '';
    });
    state.planMapFlat = [...state.planMapFlat];
    this.commit('savePersist');
  },
  updateSelectPlan(state, { plan_code, planType, billing_cycle, category, cartInfo = getCartInfo() }) {
    if (cartInfo) {
      const targetPlan = isOnlineNotSupportPlan({ planType, billingCycle: billing_cycle, category })
        ? state.planMapFlat.find((item) => item.plan_code === plan_code && item.billing_cycle === billing_cycle)
        : state.planMapFlat.find((item) => item.plan_code === plan_code);
      if (targetPlan) {
        targetPlan.cartInfo = cartInfo;
      }
      this.commit('savePersist');
    }
  },
  updateSelectPlanByCategory(state, { category, billingCycle, cartInfo = getCartInfo() }) {
    if (cartInfo) {
      const categoryPlans = state.planMapFlat.filter((item) => item.category === category);
      categoryPlans.forEach((item) => {
        if (item.billing_cycle === billingCycle) {
          item.cartInfo = cartInfo;
        }
      });
      this.commit('savePersist');
    }
  },
  updateSelectPlans(state, plans) {
    const map = plans.reduce((acc, x) => ((acc[x.plan_code] = x.cartInfo || getCartInfo()), acc), {});
    state.planMapFlat.forEach((x) => {
      if (map[x.plan_code]) {
        x.cartInfo = map[x.plan_code];
      }
    });
    this.commit('savePersist');
  },

  removeDraftPlanFilterKeysByPlanCode(state, planCode) {
    const { planMapFlat, draftPlanFilterKeys } = state;
    const selectedPlans = planMapFlat.filter((v) => v.cartInfo?.selected_number > 0);
    const planTypeCountMap = selectedPlans.reduce((acc, cur) => {

      return {
        ...acc,
        [cur.type]: (acc[cur.type] ?? 0) + 1,
      };
    }, {});
    const currentPlanType = selectedPlans.find((plan) => plan.plan_code === planCode)?.type;
    if (planTypeCountMap[currentPlanType] === 1 && draftPlanFilterKeys.includes(planTypes[currentPlanType])) {
      this.commit('removeDraftPlanFilterKeysByKey', planTypes[currentPlanType]);
    }
  },

  removePlan(state, plan_code) {
    // Minimize scope of impact, Why limit it to the checkout page? For switch plan like whiteboard to whiteboard plus
    // draftPlanFilterKeys can't be removed. this simply remove the old plan code and assign a target plan code
    if(isFromShoppingCart() && $context.is.checkoutPage) {
      this.commit('removeDraftPlanFilterKeysByPlanCode', plan_code);
    }
    state.planMapFlat.forEach((item) => {
      if (item.plan_code === plan_code) {
        item.cartInfo = getCartInfo();
      }
    });
    this.commit('savePersist');
  },
  batchRemovePlan(state, planList = []) {
    const planCodeList = planList.map((p) => p.plan_code) || [];

    state.planMapFlat.forEach((p) => {
      if (planCodeList.includes(p.plan_code)) {
        p.cartInfo = getCartInfo();
      }
    });

    this.commit('savePersist');
  },
  setAllPlanMap(state, map) {
    state.allPlanMap = map;
  },
  // PRO INCREASE - Pro Monthly Price Increase
  updateProMonthlyPlanMap(state, { currentProMonthlyPlancode, month_plancode, month_amount, address }) {
    let proMonthlyPlan = state.planMapFlat.find((p) => p.plan_code === currentProMonthlyPlancode);
    if (proMonthlyPlan) {
      // Store the data for future restore
      state.proIncreaseMapMonthly = {
        address,
        oldPlanCode: proMonthlyPlan.plan_code,
        oldPlanAmount: proMonthlyPlan.amount,
        newPlanCode: month_plancode,
        newPlanAmount: month_amount,
      };
      // Update data
      proMonthlyPlan.plan_code = month_plancode;
      proMonthlyPlan.amount = month_amount;
    }
  },
  restoreProMonthlyPlan(state, { currentProMonthlyPlancode }) {
    let proMonthlyPlan = state.planMapFlat.find((p) => p.plan_code === currentProMonthlyPlancode);
    if (
      proMonthlyPlan &&
      !!state.proIncreaseMapMonthly.oldPlanAmount &&
      state.proIncreaseMapMonthly.oldPlanCode !== currentProMonthlyPlancode
    ) {
      // Restore data
      proMonthlyPlan.plan_code = state.proIncreaseMapMonthly.oldPlanCode;
      proMonthlyPlan.amount = state.proIncreaseMapMonthly.oldPlanAmount;
      // Reset the data
      state.proIncreaseMapMonthly = {
        address: undefined,
        oldPlanCode: undefined,
        oldPlanAmount: undefined,
        newPlanCode: undefined,
        newPlanAmount: undefined,
      };
    }
  },
  // PRO INCREASE - Pro Yearly Price Increase
  updateProYearlyPlanMap(state, { currentProYearlyPlancode, yearly_plancode, yearly_amount, address }) {
    let proYearlyPlan = state.planMapFlat.find((p) => p.plan_code === currentProYearlyPlancode);
    if (proYearlyPlan) {
      // Store the data for future restore
      state.proIncreaseMapYearly = {
        address,
        oldPlanCode: proYearlyPlan.plan_code,
        oldPlanAmount: proYearlyPlan.amount,
        newPlanCode: yearly_plancode,
        newPlanAmount: yearly_amount,
      };
      // Update data
      proYearlyPlan.plan_code = yearly_plancode;
      proYearlyPlan.amount = yearly_amount;
    }
  },
  restoreProYearlyPlan(state, { currentProYearlyPlancode }) {
    let proYearlyPlan = state.planMapFlat.find((p) => p.plan_code === currentProYearlyPlancode);
    if (
      proYearlyPlan &&
      !!state.proIncreaseMapYearly.oldPlanAmount &&
      state.proIncreaseMapYearly.oldPlanCode !== currentProYearlyPlancode
    ) {
      // Restore data
      proYearlyPlan.plan_code = state.proIncreaseMapYearly.oldPlanCode;
      proYearlyPlan.amount = state.proIncreaseMapYearly.oldPlanAmount;
      // Reset the data
      state.proIncreaseMapYearly = {
        address: undefined,
        oldPlanCode: undefined,
        oldPlanAmount: undefined,
        newPlanCode: undefined,
        newPlanAmount: undefined,
      };
    }
  },
  setCartIsReady(state, data) {
    state.cartIsReady = data;
  },
  setFlowInitIsReady(state, data) {
    state.flowInitIsReady = data;
  },
  setAssignInfo(state, data) {
    state.assignInfo = data;
  },
  setCmrUsedValue(state, data) {
    state.cmrUsedValue = data;
  },
  savePersistState(state, data = {}) {
    Object.keys(data).forEach((key) => {
      state.persistState[key] = data[key];
    });
  },
  saveCurrentEditPlan(state, data = {}) {
    state.currentEditPlan = data;
  },
  setMigratePlanState(state, data = {}) {
    Object.keys(data).forEach((k) => {
      state.persistState.migratePlanState[k] = data[k];
    });
  },
  setConfirmationDetails(state, data = {}) {
    Object.keys(data).forEach((k) => {
      state.persistState.confirmationDetails[k] = data[k];
    });
  },
  setAccountBizInfo(state, data = {}) {
    Object.keys(data).forEach(k => {
      state.persistState.accountBizInfo[k] = data[k];
    })
  },
  updateHealthcare(state, data = {}) {
    Object.keys(data).forEach((key) => {
      state._healthcareInfo[key] = data[key];
    });
  },
  updateTrialInfoMap(state, { campaignCode, list = [] }) {
    Vue.set(state.trialInfoMap, campaignCode, list);
  },
  setSourcePlan(state, data) {
    state.sourcePlan = data;
  }
};

const actions = {
  async initPageFlow({ dispatch, commit, getters }) {
    await pageFlow.beforeInit?.();

    if (getters.flowInitIsReady) {
      return;
    }

    await dispatch(ADDRESS_ACTION_TYPES.fetchCountryMap);
    await Promise.all([
      dispatch('initShoppingCart'),
      dispatch(PAYMENT_ACTION_TYPES.getPaymentInfo)
    ]);

    commit('setFlowInitIsReady', true);
  },
  async initShoppingCart({ commit, state, getters, dispatch }) {
    if (getters.cartIsReady) {
      return;
    }

    const {
      boughtPlans = [],
      subscriptions = [],
      planMapFlat = [],
      allPlanMap = {},
      assignResult = {},
      freeTrialPlans = [],
      cmrUsedValue = {},
      invoiceData = null,
      sourcePlan = null
    } = await pageFlow?.init(state);

    log('init:shopping-cart', planMapFlat.filter(x => x.cartInfo?.selected_number > 0));

    commit('setAllPlanMap', allPlanMap);
    commit('setPlanMapFlat', planMapFlat);
    // setTimeout(()=>{
      // defer this to the very end so that other data init process such as ZP can catch up
      commit('setSelectedPlansMap0', planMapFlat.reduce((acc, x)=>{
        const count = x.cartInfo?.selected_number;
        if(count > 0) acc[x.plan_code] = count;
        return acc;
      }, {}));
    // }, 0)
    commit('setBoughtPlans', boughtPlans);
    commit('setSubscriptions', subscriptions);
    commit('setAssignInfo', assignResult);
    commit('setFreeTrialPlans', freeTrialPlans);
    commit('setCmrUsedValue', cmrUsedValue);
    commit('setOpenInvoiceState', invoiceData);
    sourcePlan && commit('setSourcePlan', sourcePlan);

    commit('setPreloadCartInfo', window.newBillingConfig?.preloadCartInfo || {});

    await dispatch(COUPON_ACTION_TYPES.initCouponState);

    commit("setCartIsReady", true);
    state.refreshCount++;
  },
  // todo about to be discarded
  switchSelectPlan({ commit, getters }, [oldCode, newCode, cartInfo]) {
    const oldPlanInfo = getters.getSelectedPlans.find(item => item.plan_code === oldCode);
    if (oldPlanInfo) {
      const _cartInfo = { ...(cartInfo || oldPlanInfo.cartInfo) };
      commit('updateSelectPlan', { plan_code: oldCode });
      commit('updateSelectPlan', { plan_code: newCode, cartInfo: _cartInfo });
    }
  },
  async switchSelectPlanAction({ commit, getters }, [oldCode, newPlan]) {
    const oldPlan = getters.getSelectedPlans?.find(item => item.plan_code === oldCode);

    await pageFlow?.beforeUpdate([oldPlan], [newPlan]);
    oldPlan && commit('updateSelectPlan', { plan_code: oldCode });
    newPlan && commit('updateSelectPlan', { plan_code: newPlan.plan_code, cartInfo: newPlan.cartInfo });
  },
  async switchBillingCycleAction({ commit, getters }, [oldCode, newPlan]) {
    const oldPlan = getters.getSelectedPlans?.find(item => item.plan_code === oldCode);

    await pageFlow?.beforeUpdate([oldPlan], [newPlan]);
    oldPlan && commit('updateSelectPlan', { plan_code: oldCode });
    newPlan && commit('updateSelectPlan', { plan_code: newPlan.plan_code, cartInfo: newPlan.cartInfo });
    return newPlan;
  },
  async switchCategoryAction({ commit, getters }, [oldCode, newPlan]) {
    const oldPlan = getters.getSelectedPlans?.find(item => item.plan_code === oldCode);

    await pageFlow?.beforeUpdate([oldPlan], [newPlan]);
    oldPlan && commit('updateSelectPlan', { plan_code: oldCode });
    newPlan && commit('updateSelectPlan', { plan_code: newPlan.plan_code, cartInfo: newPlan.cartInfo });
    return newPlan;
  },
  async switchCapacityAction({ commit, getters }, [oldCode, newPlan]) {
    const oldPlan = getters.getSelectedPlans?.find(item => item.plan_code === oldCode);

    await pageFlow?.beforeUpdate([oldPlan], [newPlan]);
    oldPlan && commit('updateSelectPlan', { plan_code: oldCode });
    newPlan && commit('updateSelectPlan', { plan_code: newPlan.plan_code, cartInfo: newPlan.cartInfo });
    return newPlan;
  },
  async removePlanAction({ commit, getters }, planCode) {
    const oldPlan = getters.getSelectedPlans?.find(item => item.plan_code === planCode);
    await pageFlow?.beforeUpdate([oldPlan]);
    planCode && commit('removePlan', planCode);
  },
  async batchRemovePlanAction({ commit }, planList = []) {
    await pageFlow?.beforeUpdate(planList);
    planList && planList.forEach((p) => commit("removePlan", p?.plan_code));
  },
  async fetchTrialInfos({ commit, state }, campaignCode) {
    if (state.trialInfoMap[campaignCode]) {
      return
    }
    const list = (await getFreeTrialPlansByCampaignName(campaignCode)).result || []
    commit('updateTrialInfoMap', {campaignCode, list})
    return list
  },
  switchPlanToTrialByType({ commit, getters }, type ) {
    getters.trialInfoList.filter((item) => item.type === type).forEach((trialInfo) => {
      commit('setPlanFreeTrial', {
        planCode: trialInfo.planCode,
        trialCode: trialInfo.trialCode,
        trialDays: trialInfo.trialDays,
        campaignCode: trialInfo.campaignCode
      })
    })
  },
  removePlanByKey({ commit, getters }, key) {
    // fix: plan key is lowercase, can't remove from draftPlanFilterKeys
    if (key === key?.toLowerCase?.()) {
      key = planTypes?.[key] ?? key
    }
    if (getters.draftPlanFilterKeys.includes(key)) {
      commit('removeDraftPlanFilterKeysByKey', key)
      const planType = planTypes[key];
      const currentSelectedPlans = getters.getSelectedPlans.filter((plan) => plan.type === planType);
      currentSelectedPlans.forEach((plan) => commit('removePlan', plan?.plan_code));
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
